import es from "date-fns/locale/es";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Reconocimientos from "../reconocimientos/Reconocimientos";
import Solicitudes from "../solicitudes/Solicitudes";
import "./AcumuladoresTab.scss";

registerLocale("es", es);
const AcumuladoresTab = ({
  solicitudes,
  reconocimientos,
  visibilidadRec,
  handleResolucion,
  loading,
}) => {
  const displayTabs = () => {
    return (
      <Tabs
        defaultIndex={visibilidadRec ? 0 : 1}
        /*onSelect={(index) => */
        selectedTabClassName="tab-selected"
      >
        <TabList>
         
            
        <Tab><h3 className="tituloAccesibilidadTab">Reconocimientos</h3></Tab> 
        <Tab><h3 className="tituloAccesibilidadTab">Solicitudes</h3></Tab>
            
      
        </TabList>
        {/* {reconocimientos.length !== 0 || solicitudes.length !== 0 ? (
          <> */}
            {visibilidadRec ? (
              <>
                <TabPanel>
                  <div className="acumulador-tab-panel">
                    <Reconocimientos
                      reconocimientos={reconocimientos}
                      loading={loading.reconocimientos}
                    />
                  </div>
                </TabPanel>
              </>
            ) : null}
            <TabPanel>
              <div className="acumulador-tab-panel">
                <Solicitudes
                  solicitudes={solicitudes}
                  handleResolucion={handleResolucion}
                  loading={loading.solicitudes}
                />
              </div>
            </TabPanel>
          {/* </>
        ) : (
          <>
            <SpinnerCircle></SpinnerCircle>
          </>
        )} */}
      </Tabs>
    );
  };

  return (
    <>
      <div className="acumuladoresTab col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div>{displayTabs()}</div>
      </div>
    </>
  );
};
export default AcumuladoresTab;
